"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var companyappApi = _interopRequireWildcard(require("@/api/companyappApi"));
var _validate = require("@/utils/validate");
var _enum = require("../../enum");
var logistics = _interopRequireWildcard(require("@/api/logistics"));
var _api = require("../api");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var props = {
  children: 'child',
  label: 'name',
  value: 'id',
  emitPath: false
};
function _default(_ref) {
  var handleSearch = _ref.handleSearch;
  var FILTER_ITEMS = [{
    type: 'input',
    label: '消费券名称：',
    prop: 'name',
    attrs: {
      placeholder: '请输入内容',
      clearable: true
    },
    events: {
      input: (0, _validate.Debounce)(function (value) {
        return handleSearch({
          name: value
        });
      })
    }
  }, {
    type: 'select',
    label: '消费券状态：',
    prop: 'status',
    attrs: {
      placeholder: '请选择',
      clearable: true
    },
    options: [{
      label: '未开始',
      value: 0
    }, {
      label: '已开始',
      value: 1
    }, {
      label: '已关闭',
      value: 2
    }, {
      label: '异常关闭',
      value: 3
    }],
    events: {
      change: function change(value) {
        return handleSearch({
          status: value
        });
      }
    }
  }, {
    type: 'cascader',
    label: '可领取地区：',
    prop: 'areaScope',
    attrs: {
      placeholder: '请选择省/市/区（县），支持搜索',
      clearable: true,
      filterable: true,
      props: {
        value: 'name',
        label: 'name',
        children: 'child',
        expandTrigger: 'hover',
        emitPath: true
      },
      'show-all-levels': false,
      style: 'width: 300px;',
      options: []
    },
    events: {
      change: function change(value) {
        // 将三级路径数组转换为字符串，用于搜索
        // value可能是单个路径数组或数组的数组
        var areaValue = '';
        if (value && value.length > 0) {
          if (Array.isArray(value[0])) {
            // 多选模式，取第一个选择的地区
            areaValue = value[0].join(' / ');
          } else {
            // 单选模式
            areaValue = value.join(' / ');
          }
        }
        handleSearch({
          areaScope: areaValue
        });
      }
    }
  }, {
    type: 'select',
    label: '券类型：',
    prop: 'voucherType',
    attrs: {
      placeholder: '请选择',
      clearable: true
    },
    options: [],
    events: {
      change: function change(value) {
        return handleSearch({
          voucherType: value
        });
      }
    }
  }, {
    type: 'select',
    label: '用于积分兑换：',
    prop: 'isIntegralExchange',
    attrs: {
      placeholder: '请选择',
      clearable: true
    },
    options: [{
      label: '是',
      value: 1
    }, {
      label: '否',
      value: 0
    }],
    events: {
      change: function change(value) {
        return handleSearch({
          isIntegralExchange: value
        });
      }
    }
  }, {
    type: 'picker',
    label: '消费券有效期：',
    prop: 'lifespanTime',
    attrs: {
      placeholder: '请选择',
      type: 'datetimerange',
      clearable: true,
      'start-placeholder': "开始日期时间",
      'end-placeholder': "结束日期时间",
      'value-format': 'yyyy-MM-dd HH:mm:ss'
    },
    events: {
      change: function change(value) {
        return handleSearch({
          lifespanTime: value
        });
      }
    }
  }];

  // 异步加载地区数据（三级联动树形结构）
  function loadAreaData() {
    return _loadAreaData.apply(this, arguments);
  } // 异步加载券类型字典
  function _loadAreaData() {
    _loadAreaData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var res, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return logistics.treeLevel3();
          case 1:
            res = _context.v;
            console.log('地区数据加载结果:', res);
            // 返回数据，由组件使用$set来更新，确保响应式
            return _context.a(2, res && Array.isArray(res) ? res : []);
          case 2:
            _context.p = 2;
            _t = _context.v;
            console.error('加载地区数据失败:', _t);
            return _context.a(2, []);
        }
      }, _callee, null, [[0, 2]]);
    }));
    return _loadAreaData.apply(this, arguments);
  }
  function loadVoucherTypeDict() {
    return _loadVoucherTypeDict.apply(this, arguments);
  } // 加载数据
  function _loadVoucherTypeDict() {
    _loadVoucherTypeDict = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var res, voucherTypeItem, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            _context2.n = 1;
            return (0, _api.getVoucherTypeDictApi)();
          case 1:
            res = _context2.v;
            if (res && Array.isArray(res)) {
              voucherTypeItem = FILTER_ITEMS.find(function (item) {
                return item.prop === 'voucherType';
              });
              if (voucherTypeItem) {
                voucherTypeItem.options = res.map(function (item) {
                  return {
                    label: item.value,
                    value: item.code
                  };
                });
              }
            }
            _context2.n = 3;
            break;
          case 2:
            _context2.p = 2;
            _t2 = _context2.v;
            console.error('加载券类型字典失败:', _t2);
          case 3:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 2]]);
    }));
    return _loadVoucherTypeDict.apply(this, arguments);
  }
  loadVoucherTypeDict();
  // 注意：loadAreaData需要在Vue组件mounted后调用，以确保响应式更新
  // 这里只返回函数，不在配置中直接调用
  // loadAreaData();

  return {
    FILTER_ITEMS: FILTER_ITEMS,
    loadAreaData: loadAreaData // 导出函数供组件调用
  };
}